import React from 'react';
import { useModalStore } from '../../stores/useUIStore';

// Importa todos los componentes de modales que usarás
import CreatePostModal from './CreatePostModal'; // 🟢 SOLUCIÓN: Apuntamos al archivo correcto en la misma carpeta.
import UploadPhotosModal from '../profile/UploadPhotosModal';
import UploadClipModal from '../profile/UploadClipModal';
import AddMusicModal from '../profile/AddMusicModal';
import ProfileSettingsModal from '../profile/ProfileSettingsModal';
import RegisterModal from '../common/RegisterModal'; // 🟢 IMPORTANTE: Importamos el modal de Auth
import CreateAdForm from '../ads/CreateAdForm'; // 🟢 1. Importamos el formulario de anuncios
import PhotoSelectionModal from '../profile/PhotoSelectionModal';
import CreateCampaignModal from '../company/CreateCampaignModal'; // 🟢 1. Importamos el modal de campañas
import CreateStoryModal from '../story/CreateStoryModal';
import StoryViewer from '../story/StoryViewer';
import CommentModal from '../posts/CommentModal';
import ForwardPostModal from '../posts/ForwardPostModal';
import ProfessionalProfileConsentModal from '../profile/ProfessionalProfileConsentModal'; // 🟢 Importamos el nuevo modal
import ProfessionalProfilePreviewModal from '../profile/ProfessionalProfilePreviewModal'; // 🟢 Importamos el modal de vista previa
import CreateAdminEventModal from './CreateAdminEventModal'; // 🟢 SOLUCIÓN: Importamos el modal de creación de eventos
import CreateAdminUserModal from './CreateAdminUserModal'; // 🟢 SOLUCIÓN: Importamos el modal de creación de usuarios admin
import AdminEventDetailsModal from './AdminEventDetailsModal'; // 🟢 SOLUCIÓN: Importamos el modal de detalles de eventos
import SendWarningModal from './SendWarningModal'; // 🟢 SOLUCIÓN: Importamos el modal de envío de advertencias
import RequestTaskClosureModal from './RequestTaskClosureModal';
import ValidateTaskClosureModal from './ValidateTaskClosureModal';
import CreateTaskModal from './CreateTaskModal'; // 🟢 Importamos el modal de creación de tareas
import MultimediaModal from './MultimediaModal'; // 🟢 Importamos el modal multimedia
import ClipPlayerModal from '../profile/ClipPlayerModal';
import UploadIdentityDocumentModal from '../profile/UploadIdentityDocumentModal';
import ProfileFaqModal from '../profile/ProfileFaqModal';
import MemoriesModal from '../profile/MemoriesModal';
import { useProfileStore } from '../../stores/useDataStore';

const GlobalModals = () => {
  const modals = useModalStore((state) => state.modals);
  const closeModal = useModalStore((state) => state.closeModal);
  const searchMusic = useProfileStore((state) => state.searchMusic);
  const addSongs = useProfileStore((state) => state.addSongs);

  // 🟢 SOLUCIÓN: Mapeamos los modales a sus componentes y nos aseguramos de pasar las props correctamente.
  const modalComponents = {
    createPost: CreatePostModal,
    uploadPhotos: UploadPhotosModal,
    uploadClip: UploadClipModal,
    addMusic: AddMusicModal,
    photoSelection: PhotoSelectionModal,
    createStory: CreateStoryModal,
    createAd: CreateAdForm, // 🟢 2. Añadimos el formulario de anuncios al mapa
    createCampaign: CreateCampaignModal, // 🟢 2. Añadimos el modal de campañas
    userAdCreator: CreateAdForm, // 🟢 FASE 4: unificación en formulario oficial
    storyViewer: StoryViewer,
    commentModal: CommentModal,
    forwardPost: ForwardPostModal,
    professionalProfileConsent: ProfessionalProfileConsentModal, // 🟢 Lo registramos aquí
    professionalProfilePreview: ProfessionalProfilePreviewModal, // 🟢 Lo registramos aquí
    profileSettings: ProfileSettingsModal,
    clipPlayer: ClipPlayerModal,
    memories: MemoriesModal,
    createAdminUser: CreateAdminUserModal, // 🟢 SOLUCIÓN: Registramos el nuevo modal
    sendWarning: SendWarningModal, // 🟢 SOLUCIÓN: Registramos el modal de advertencias
    createAdminEvent: CreateAdminEventModal, // 🟢 SOLUCIÓN: Registramos el nuevo modal
    adminEventDetails: AdminEventDetailsModal, // 🟢 SOLUCIÓN: Registramos el nuevo modal
    requestTaskClosure: RequestTaskClosureModal,
    validateTaskClosure: ValidateTaskClosureModal,
    createTaskModal: CreateTaskModal, // 🟢 Registramos el modal de creación de tareas
    uploadIdentityDocument: UploadIdentityDocumentModal,
    profileFaqs: ProfileFaqModal,
  };

  return (
    <>
      {/* 🟢 Renderizamos RegisterModal fuera del bucle porque maneja su propia lógica de visibilidad y z-index */}
      <RegisterModal />
      {/* 🟢 Renderizamos MultimediaModal fuera del bucle para evitar doble overlay y pasar props específicas */}
      <MultimediaModal onSend={modals.multimediaModal?.data?.onSend} />

      {Object.entries(modals).map(([modalName, modalState]) => {
        const Component = modalComponents[modalName];
        if (!modalState.isOpen || !Component) {
          return null;
        }

        if (modalName === 'createPost') {
          console.log('[DEBUG GlobalModals] modalState.data recibido para createPost:', modalState.data);
        }

        // 🟢 SOLUCIÓN: Pasamos los datos del modal dentro de una prop `modalData`.
        const componentProps = {
          isOpen: modalState.isOpen,
          onClose: () => closeModal(modalName),
          modalData: modalState.data, // Los datos ahora van encapsulados en `modalData`.
          ...(modalState.data || {}),
        };

        if (modalName === 'addMusic') {
          componentProps.onSearch = searchMusic;
          componentProps.onAddSong = addSongs;
        }

        if (modalName === 'uploadClip') {
          componentProps.username = modalState.data?.username;
        }

        if (modalName === 'clipPlayer') {
          componentProps.clip = modalState.data?.clip;
        }

        if (modalName === 'createAd') {
          componentProps.isAdminMode = true;
        }

        if (modalName === 'createAd' || modalName === 'userAdCreator') {
          componentProps.onFormSubmit = () => {
            const callback = modalState.data?.onSuccess;
            if (typeof callback === 'function') {
              callback();
            }
            closeModal(modalName);
          };
        }

        if (modalName === 'storyViewer' || modalName === 'commentModal') {
          return <Component key={modalName} {...componentProps} />;
        }

        const disableOverlayClose = ['photoSelection', 'uploadPhotos', 'uploadClip'].includes(modalName);

        return (
          // 🟢 SOLUCIÓN: Envolvemos cada modal en una estructura contenedora
          // que le da el comportamiento de ventana emergente.
          <div 
            key={modalName} 
            className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[9999] p-4" 
            onClick={disableOverlayClose ? undefined : () => closeModal(modalName)}
          >
            <div onClick={(e) => e.stopPropagation()}>
              <Component {...componentProps} />
            </div>
          </div>
        );
      })}
    </>
  );
};

export default GlobalModals;